import React from 'react';
import styled, { keyframes } from 'styled-components';
import rocket from '../assets/rotatedrocket.png';
import stars from '../assets/stars.jpg';

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background-image: url(${stars});
`;

const Loader = styled.div`
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const orbit = keyframes`
  0% {
    transform: rotate(360deg) translateX(100px);
  }
  100% {
    transform: rotate(0deg) translateX(100px);
  }`;
const Rocket = styled.div`
  width: 6rem;
  height: 6rem;
  background-image: url(${rocket});
  background-size: contain;
  background-repeat: no-repeat;
  animation: ${orbit} 2s linear infinite;
`;

const dots = keyframes`
  0%, 20% {
    content: "";
  }
  40% {
    content: ".";
  }
  60% {
    content: "..";
  }
  80%, 100% {
    content: "...";
  }
`;

const TextLoader = styled.div`
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
`;

const AnimatedDots = styled.span`
  &::after {
    content: "";
    animation: ${dots} 2s ease-in-out infinite;
  }
`;

const Loading = () => {
    return (
      <LoadingContainer>
        <Loader>
            <Rocket />
            <TextLoader>Loading<AnimatedDots /></TextLoader>
        </Loader>
      </LoadingContainer>
    );
};

export default Loading;
